import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { ConfiguratedValidator, Default, EditorDefinition, Expose, IsNotEmpty, Model, ModelId } from '@core/shared/model';
import { usernameOrEmailUserItemValidator } from '@common/users/shared/validators';
let AuthenticateResponse = /*#__PURE__*/(() => {
  let AuthenticateResponse = class AuthenticateResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], AuthenticateResponse.prototype, "sessionId", void 0);
  AuthenticateResponse = __decorate([ModelId("AuthenticateResponse") // auto-generated by generate-model-ids
  ], AuthenticateResponse);
  return AuthenticateResponse;
})();
export { AuthenticateResponse };
let AuthenticateRequest = /*#__PURE__*/(() => {
  let AuthenticateRequest = class AuthenticateRequest extends Model {
    static {
      this.Response = AuthenticateResponse;
    }
  };
  __decorate([ConfiguratedValidator(usernameOrEmailUserItemValidator), IsNotEmpty(), Expose(), Default(''), __metadata("design:type", String)], AuthenticateRequest.prototype, "username", void 0);
  __decorate([IsNotEmpty(), Expose(), Default(''), __metadata("design:type", String)], AuthenticateRequest.prototype, "password", void 0);
  AuthenticateRequest = __decorate([AppRequest('auth/credentials', 'authenticate', {
    httpMethod: AppRequestMethod.POST,
    disallowInternal: true,
    requiredAccessData: ['sessionId']
  }), EditorDefinition({}, {
    allowAllExposed: true,
    useAppRequest: true
  }), ModelId("AuthenticateRequest") // auto-generated by generate-model-ids
  ], AuthenticateRequest);
  return AuthenticateRequest;
})();
export { AuthenticateRequest };